<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="TITLE">A Theology<br/>of Grace<br/>in Six Controversies</p>
<p class="AUTHOR">Edward T. Oakes, S.J.</p>
<p class="COMPANY">William B. Eerdmans Publishing Company<br/>Grand Rapids, Michigan</p>
<p class="IMPRIMATUR-FIRST">© 2016 Jesuits USA Central &amp; Southern Province<br/>All rights reserved</p>
<p class="IMPRIMATUR"><em class="italic">Imprimi potest:</em>	V. Rev. Douglas Marcouiller, S.J.<br/>	Provincial, Missouri Province of the Society of Jesus<br/>	September 1, 2013</p>
<p class="IMPRIMATUR"><em class="italic">Nihil obstat:</em>	Rev. Thomas G. Weinandy, O.F.M., Cap.<br/> <em class="italic">Censor deputatus<br/></em>	Capuchin College, Washington, D.C.<br/>	August 29, 2013</p>
<p class="IMPRIMATUR"><em class="italic">Imprimatur:</em>	Francis Cardinal George, O.M.I., Ph.D., S.T.D<br/>	Archbishop of Chicago<br/>	September 4, 2012</p>
<p class="IMPRIMATUR">In accordance with Canon 824, permission to publish was granted by His Eminence, Francis Cardinal George, O.M.I., Archbishop of Chicago. The <em class="italic">Nihil obstat</em> and <em class="italic">Imprimatur</em> are official declarations that the book is free from doctrinal and moral error. No implication is contained therein that those who have granted the <em class="italic">Nihil obstat</em> and <em class="italic">Imprimatur</em> agree with the content, opinions, or statements expressed. No legal responsibility is assumed by the grant of this permission.</p>
<p class="IMPRIMATUR">Published 2016 by<br/>Wm. B. Eerdmans Publishing Co.<br/>2140 Oak Industrial Drive N.E., Grand Rapids, Michigan 49505</p>
<p class="IMPRIMATUR">Printed in the United States of America</p>
<p class="LIBRARY">Library of Congress Cataloging-in-Publication Data</p>
<p class="CIP">Names: Oakes, Edward T., author.</p>
<p class="CIP">Title: A theology of grace in six controversies / Edward T. Oakes, S.J.</p>
<p class="CIP">Description: Grand Rapids, Michigan: Eerdmans Publishing Company, 2016. | <br/>Series: Interventions</p>
<p class="CIP">Identifiers: LCCN 2015045476 | ISBN 9780802873200 (pbk: alk. paper)<br/>eISBN 9781467445368 (ePub)<br/>eISBN 9781467444897 (Kindle)</p>
<p class="CIP">Subjects: LCSH: Grace (Theology) | Salvation—Christianity. | Catholic Church—Doctrines.</p>
<p class="CIP">Classification: LCC BT761.3 .O225 2016 | DDC 234—dc23<br/>LC record available at http://lccn.loc.gov/2015045476</p>
<p class="URL"><a href="http://www.eerdmans.com" target="_blank">www.eerdmans.com</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Oakes_A_Theology_of_Grace2.vue?03c010d5